import { MessageSquarePlus } from 'lucide-react';
import { motion } from 'motion/react';
import { useState } from 'react';

import { cn } from '@workspace/shadcn';

import { useModals } from './modals.tsx';

const pulseAnimation = {
  scale: [1, 1.05, 1],
  transition: {
    duration: 2,
    repeat: Infinity,
    repeatType: 'reverse' as const,
  },
};

export function SuggestionBubbleButton() {
  const { openModal, open, close } = useModals();
  const [isHovered, setIsHovered] = useState(false);

  const isContactModalOpen = openModal === 'contact' || openModal === 'course';
  const isSuggestionModalOpen = openModal === 'suggestion';

  return (
    <div
      className={cn(
        'fixed end-4 bottom-4 z-50 flex flex-col items-center md:end-6 md:bottom-6',
        isContactModalOpen && 'opacity-20 blur-md grayscale',
      )}
    >
      <motion.div
        className="bg-card mb-2 hidden rounded-md px-3 py-1 text-sm font-medium shadow-md md:block"
        initial={{ opacity: 0.6, y: 10 }}
        animate={{ opacity: isHovered ? 1 : 0.6, y: 0 }}
        transition={{ duration: 0.2 }}
      >
        Suggest a course
      </motion.div>
      <motion.button
        aria-label="Suggest a course"
        className="bg-primary text-primary-foreground flex h-12 w-12 items-center justify-center rounded-full shadow-lg md:h-16 md:w-16"
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.9 }}
        animate={!isSuggestionModalOpen ? pulseAnimation : {}}
        onClick={() => (isSuggestionModalOpen ? close() : open('suggestion'))}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        disabled={isContactModalOpen}
      >
        <MessageSquarePlus
          size={20}
          className="text-white md:h-6 md:w-6 dark:text-black"
        />
      </motion.button>
    </div>
  );
}
